const state = { all: {} };
import { apiService } from "@/_services";

const actions = {
  async getAll({ commit }) {
    let params = {
      method: "GET",
      endpoint: "futures",
      content_type: "application/json",
      query_params: {
        format: "json",
      },
    };
    commit("getAllRequest");
    await apiService
      .getAll(params)
      .then((data) => {
        commit("getAllSuccess", data);
      })
      .catch((error) => {
        console.log(error);
        commit("getAllFailure", error);
      });
  },
  logout({ commit }) {
    commit("logout");
  },
};

const mutations = {
  getAllRequest(state) {
    state.all = { loading: true };
  },
  getAllSuccess(state, futures) {
    state.all = { items: futures };
  },
  getAllFailure(state, error) {
    state.all = { error };
  },
  logout(state) {
    state.all = null;
  },
};

export const futures = {
  namespaced: true,
  state,
  actions,
  mutations,
};
